import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div style={{ textAlign: "center", marginTop: "2rem" }}>
      <h1>Welcome to Simplest Feedback</h1>
      <p>This is the home page. Please <Link to="/login">Login</Link> to access your dashboard.</p>
    </div>
  );
}

export default Home; 